import React from 'react'
import { gql } from '@apollo/client'
import { initializeApollo } from 'gql/client'
import { PAGINA } from 'utils/queries'
import MyAccountHomeTemplate from 'components/templates/MyAccountHomeTemplate/MyAccountHomeTemplate'
import { NextWrapper } from 'data-fetching-wrapper'

const AccountHomePage = ({ pagina }) => <MyAccountHomeTemplate pagina={pagina} />

export const getStaticProps = NextWrapper.getStaticProps(async ({ locale }) => {
  const client = initializeApollo(null,null,null,locale)

  const {
    data: { pagina },
  } = await client.query({
    query: gql`
      ${PAGINA.replace('__chiave__', "myaccount")}
    `,
  })

  if (!pagina) {
    return {
      notFound: true,
    }
  }

  return {
    props: { pagina }, // will be passed to the page component as props
    revalidate: 60, // In seconds
  }
}, '/account/')

AccountHomePage.loginRequired = true

export default AccountHomePage
